<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card card-top-line">
          <!-- Header -->
          <div class="header d-flex justify-content-between align-items-center">
            <h2>Add Ambassador</h2>
          </div>
          <div class="body pt-0">
            <div
              class="d-md-flex justify-content-between align-items-center mb-2"
            >
              <div
                class="form-group mb-0 form-select multiselect-grp w-100 mr-1"
              >
                <span class="float-label">
                  <label for="customer">Select Customer</label>
                  <multiselect
                    placeholder=""
                    v-model="searchedCustomer"
                    :show-labels="false"
                    :options="options"
                    :searchable="true"
                    @search-change="searchCustomer"
                    track-by="name"
                    label="name"
                  >
                    <template #option="props">
                      <div class="option__desc">
                        {{ props.option.name + ` (${props.option.email})` }}
                      </div>
                    </template>
                  </multiselect>
                </span>
              </div>
              <b-button
                class="btn btn-auto"
                variant="outline-primary"
                @click="addNew()"
              >
                Add Ambassador
              </b-button>
            </div>
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <!-- Share and Save Coupon Listing -->
            <b-table
              responsive
              table-class="mb-0 table-custom border"
              head-variant="light"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              striped
            >
              <template #head()="{ label, field: { key } }">
                {{ label }}
                <!-- Custom icons -->
                <template>
                  <i v-if="sortBy !== key" class=""></i>
                  <i
                    v-else-if="sortDesc"
                    class="fa fa-long-arrow-down ml-1"
                  ></i>
                  <i v-else class="fa fa-long-arrow-up ml-1"></i>
                </template>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="py-3 align-items-center justify-content-between table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AddAmbassadorComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    Multiselect: () => import("vue-multiselect"),
  },
  data() {
    return {
      items: [
        {
          ambassador_name: "Ben Murphy",
          mobile: "+447799691752",
          referral_code: "48sada48f",
          created_by: "Selena Parker",
          date_time: "2024-05-20",
          is_suspended: false,
        },
        {
          ambassador_name: "Robert Evans",
          mobile: "+233263456785",
          referral_code: "i18as2da48f",
          created_by: "Jones Amegbor",
          date_time: "2024-05-20",
          is_suspended: false,
        },
        {
          ambassador_name: "Lusifer Boswell",
          mobile: "+447799691752",
          referral_code: "1as2esa121s2",
          created_by: "Selena Parker",
          date_time: "2024-05-20",
          is_suspended: false,
        },
        {
          ambassador_name: "Mark Richards",
          mobile: "+233263456785",
          referral_code: "a4asdf3e8f",
          created_by: "Selena Parker",
          date_time: "2024-05-20",
          is_suspended: false,
        },
      ],
      searchedCustomer: "",

      fields: [
        {
          key: "ambassador_name",
          label: "Ambassador Name",
          sortable: true,
          thClass: "th_sortfix",
        },
        { key: "mobile", label: "Mobile", thClass: "th_sortfix" },
        { key: "referral_code", label: "Referral Code", thClass: "th_sortfix" },
        {
          key: "created_by",
          label: "Created By",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "date_time",
          label: "Date Time",
          sortable: true,
          thClass: "th_sortfix",
        },
        { key: "is_suspended", label: "Is Suspended", thClass: "th_sortfix" },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],
      options: [],

      totalRows: 1,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 50,
      pageOptions: [50, 100, 150, { value: 1000, text: 1000 }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
    };
  },
  methods: {
    addNew() {
      console.log(this.searchedCustomer);
    },
    searchCustomer($event) {
      if ($event.length > 0) {
        this.options = [
          { name: "Adam Driver", email: "AdamD@yopmail.com" },
          { name: "Dominic Torreto", email: "Dominic@hotmail.co" },
          { name: "Brain O'Conner", email: "connerBrain@mailinator.com" },
          { name: "Mark Chalamet", email: "mark21@test.com" },
          { name: "Robert Evans", email: "robEv12@yahoo.com" },
          { name: "Emma Thomas", email: "emthomas@mail.com" },
          { name: "Alizee Thomas", email: "alizze.th@hotmail.com" },
          { name: "Selena Parker", email: "selena.tp@test.in" },
          { name: "Hal Chalamet", email: "halC12@gmail.com" },
          { name: "Ben Murphy", email: "benPM99@gmail.com" },
        ];
      } else {
        this.options = [];
      }
    },
    onEnter(e) {
      var paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = this.currentPageJump = e.target.value;
        } else {
          this.currentPage = this.currentPageJump = paginationMenu;
        }
      } else {
        this.currentPage = this.currentPageJump = 1;
      }
    },
  },
  mounted() {
    this.totalRows = this.items.length;
  },
};
</script>
